import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/icons/abc.png'
import _imports_1 from '@/assets/images/icons/light.png'
import _imports_2 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { class: "p-6 bg-white shadow-sm rounded-2xl mb-10" }
const _hoisted_2 = { class: "flex items-center justify-between mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600" }, " Thống kê chung ", -1)
const _hoisted_4 = {
  key: 0,
  type: "button",
  class: "button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.75111 7.3111 8.68202 6.24922 7.87633 5.00267Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_6 = { class: "flex flex-nowrap w-full md-down:flex-col" }
const _hoisted_7 = { class: "p-6 border rounded-l-lg border-neutral-200 w-full md:border-r-0 md-down:border-b-0 md-down:rounded-t md-down:rounded-b-none" }
const _hoisted_8 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực ")
], -1)
const _hoisted_11 = { class: "p-6 border rounded-r-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none" }
const _hoisted_12 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu")
], -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_17 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_18 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_19 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_20 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      style: {"min-width":"160px"}
    }, " Nội dung ")
  ])
], -1)
const _hoisted_22 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_23 = { class: "ml-2" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_25 = {
  class: "flex gap-2 flex-wrap",
  style: {"max-width":"360px"}
}
const _hoisted_26 = {
  key: 0,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input whitespace-nowrap",
  style: {"font-size":"10px"}
}
const _hoisted_27 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_28 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  height: "250",
  width: "250"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 text-center text-lg" }, " Con chưa có mục tiêu hoàn thành ", -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          false
            ? (_openBlock(), _createElementBlock("button", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(" Chỉnh sửa ")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.skill_count), 1)
          ]),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.goal_count), 1)
          ]),
          _hoisted_14
        ])
      ])
    ]),
    (_ctx.goals && _ctx.goals.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals, (goal, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "mb-10",
                key: index
              }, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(index + 1) + ". " + _toDisplayString(goal.skill.name), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("table", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goal.goals, (g, i) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: g.id,
                              class: _normalizeClass([
												i % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											, "text-neutral-700"])
                            }, [
                              _createElementVNode("td", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(i + 1), 1)
                              ]),
                              _createElementVNode("td", _hoisted_24, [
                                _createVNode(_component_router_link, {
                                  to: `/goal/${_ctx.id}/${g.id}`
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, _toDisplayString(g.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createElementVNode("div", _hoisted_25, [
                                  (g?.display_source)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(g?.display_source), 1))
                                    : _createCommentVNode("", true),
                                  (
															g?.assistance_levels &&
															_ctx.org.enable_goal_assistance_level
														)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(g?.assistance_levels, (ass) => {
                                        return (_openBlock(), _createElementBlock("div", { key: ass }, [
                                          _createElementVNode("div", _hoisted_27, _toDisplayString(ass), 1)
                                        ]))
                                      }), 128))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
  ]))
}